import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const findAll = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('pagos-detalles-solicitudes'), { params });
};

const create = async (data) => {
  return await axiosIns.post(obtenerUrl('pagos-detalles-solicitudes'), data);
};

const obtenerArchivoAdjunto = async (id) => {
  return await axiosIns.get(obtenerUrl(`pagos-detalles-solicitudes/${id}/archivo-adjunto`));
};

const subirArchivoAdjunto = async (id, data) => {
  return await axiosIns.post(obtenerUrl(`pagos-detalles-solicitudes/${id}/archivo-adjunto`), data);
};

export default {
  findAll,
  create,
  obtenerArchivoAdjunto,
  subirArchivoAdjunto,
};
